/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 11.1.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Specifies the precision of an encoded polyline.
 * @export
 */
export const ShapeFormat = {
  Polyline6: "polyline6",
  Polyline5: "polyline5",
} as const;
export type ShapeFormat = (typeof ShapeFormat)[keyof typeof ShapeFormat];

export function instanceOfShapeFormat(value: any): boolean {
  for (const key in ShapeFormat) {
    if (Object.prototype.hasOwnProperty.call(ShapeFormat, key)) {
      if (ShapeFormat[key as keyof typeof ShapeFormat] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ShapeFormatFromJSON(json: any): ShapeFormat {
  return ShapeFormatFromJSONTyped(json, false);
}

export function ShapeFormatFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ShapeFormat {
  return json as ShapeFormat;
}

export function ShapeFormatToJSON(value?: ShapeFormat | null): any {
  return value as any;
}

export function ShapeFormatToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ShapeFormat {
  return value as ShapeFormat;
}
